export default __webpack_public_path__ + "static/media/marinara.40f53721.png";